<!--仓库管理 -  盘库 - 详情-->
<template>
  <div id="stockdetail">
    <el-row style="margin: 20px auto">
      <el-col :xl="4" :lg="4" :md="6">
        <span>盘库日期：{{ titleList[0].ENTRY_DATE }}</span>
      </el-col>
      <el-col :xl="6" :lg="8" :md="12">
        <span>盘库单编号：{{ titleList[0].PK_CODE }}</span>
      </el-col>
      <el-col :xl="3" :lg="4" :md="6">
        <span>总金额：{{ titleList[0].AFTER_WORTH }}</span>
      </el-col>
      <el-col :xl="{ span: 1, offset: 7 }" :lg="{ span: 1, offset: 2 }" :md="{ span: 1, offset: 1 }">
        <el-button size="medium" type="primary" plain @click="$_exportStock()">导出盘库单</el-button>
      </el-col>
      <el-col :xl="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 2 }" :md="{ span: 1, offset: 3 }">
        <el-button size="medium" @click="toPrintTable">打印盘库单</el-button>
      </el-col>
    </el-row>
    <el-row style="margin:30px 0">
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="50"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="60"></el-table-column>
          <el-table-column prop="LOCATION_CODE" label="库位" min-width="60" v-if="WAREHOUSE_MODE == 2"></el-table-column>
          <el-table-column prop="BEFORE_COUNT" label="盘前库存" min-width="45"></el-table-column>
          <el-table-column prop="AFTER_COUNT" label="盘后库存" min-width="45"></el-table-column>
          <el-table-column label="数量差异" min-width="45">
            <template slot-scope="scope">
              <span :style="$_setFontColor(scope.row.AFTER_COUNT - scope.row.BEFORE_COUNT)">
                {{ (Number(scope.row.AFTER_COUNT) - Number(scope.row.BEFORE_COUNT)).toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="45"></el-table-column>
          <el-table-column prop="BEFORE_WORTH" label="盘前总额" min-width="45"></el-table-column>
          <el-table-column prop="AFTER_WORTH" label="盘后总额" min-width="45"></el-table-column>
          <el-table-column label="盘盈/盘亏" min-width="45">
            <template slot-scope="scope">
              <span :style="$_setFontColor(scope.row.CURRENT_OFFSET_WORTH)">{{ scope.row.CURRENT_OFFSET_WORTH }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
      layout="total,prev, pager, next, jumper" :total="total_count">
    </el-pagination>
  </div>
</template>
<script>
import {
  setFontColor, print, queryStokDetailFun, exportPKFun,
} from 'api/warehouseManager';

export default {
  data () {
    return {
      userName: sessionStorage.getItem('name'),
      projectName: sessionStorage.getItem('gysName'),
      tableData: [],
      titleList: [{
        ENTRY_DATE: '',
        PK_CODE: '',
      }],
      total_count: 0,
      currentPage: 1,
      pageSize: 10,
      ALL_PRODUCTS: [],
      创建盘库单人名称: '',
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      fromProfitLossTable: false,
      // loading: false
    };
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      if (from.name == 'profitLossTable') {
        that.fromProfitLossTable = true;
      }
    });
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
  },
  methods: {
    // -----------------------------------------------分页加载当前产品
    loadPageProducts (pageIndex = 0, pageSize = this.pageSize) {
      const INDEX = pageIndex * pageSize;
      const END = INDEX + pageSize;
      if (END > this.ALL_PRODUCTS.length) {
        this.tableData = this.ALL_PRODUCTS.slice(INDEX);
      } else {
        this.tableData = this.ALL_PRODUCTS.slice(INDEX, END);
      }
    },
    // ----------------------------------页码改变时触发
    handleCurrentChange (page) {
      this.currentPage = page;
      this.loadPageProducts(page - 1);
    },
    // ----------------------------------拉取数据
    queryData () {
      const data = {
        PK_ID: Number(sessionStorage.getItem('pk_id')),
        PK_CODE: sessionStorage.getItem('pk_code'),
      };
      queryStokDetailFun(data).then((result) => {
        if (result[0]) {
          this.tableData = result[0].PK_DETAIL;
          this.titleList = result[0].OP_ROLE;
          this.total_count = result[0].PK_DETAIL.length;
          this.ALL_PRODUCTS = result[0].PK_DETAIL;
          this.创建盘库单人名称 = result[1].OR ? result[1].OR[0].DATA[1].N : '';
          this.loadPageProducts();
        } else {
          this.tableData = [];
          this.titleList = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 设置盘盈盘亏颜色显示
    $_setFontColor (number) {
      return setFontColor(Number(number));
    },
    // 打印
    toPrintTable () {
      let html = '<div>';
      html += '<div class="main">';
      html += '<div class="title">盘库详情</div>';
      html += `<div class="head"><div class="code">供应商：${this.projectName}</div><div>盘点合计金额：${this.titleList[0].AFTER_WORTH}</div></div>`;
      html += `<div class="head"><div class="code">盘库单编号：${this.titleList[0].PK_CODE}</div><div>日期：${this.titleList[0].ENTRY_DATE}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th>产品</th> <th  style="width: 40px">单位</th> <th style="width: 70px">盘前库存</th> <th  style="width: 70px">盘库库存</th> <th>单价</th>  <th  style="width: 70px">盘前金额</th>  <th  style="width: 70px">盘后金额</th>  <th  style="width: 80px">盘盈/盘亏</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.ALL_PRODUCTS.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_NAME}</td> <td>${item.TYPE_UNIT}</td>
                 <td>${item.BEFORE_COUNT}</td> <td>${item.AFTER_COUNT}</td> <td>${item.PRODUCT_PRICE}</td>
                 <td>${item.BEFORE_WORTH}</td> <td>${item.AFTER_WORTH}</td>
                 <td>${item.CURRENT_OFFSET_WORTH}</td>`;
        html += '</tr>';
      });

      html += '<tr style="text-align: center;font-size: 14px;font-weight: bold;">';
      html += '<td colspan="8">合计</td>';
      html += `<td>${this.titleList[0].PK_VALUE}</td>`;
      html += '</tr>';


      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += `<div style="margin-top: 20px; display: flex; flex-direction: row;"><div>操作人：${this.userName}</div><div style="margin-left: 200px">盘点人：</div><div style="margin-left: 200px">制单人名称：${this.创建盘库单人名称}</div> </div>`;
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
    // 导出盘库单详情
    $_exportStock () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            PK_ID: Number(sessionStorage.getItem('pk_id')),
            WAREHOUSE_MODE: this.WAREHOUSE_MODE,
          };
          exportPKFun(data)
            .then((res) => {
              window.location.href = res[0].FILE_PATH;
              document.body.style.cursor = 'default';
            }).catch((err) => {
              this.$message.show({ text: err, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally { }
      }
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockDetail.vue